import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { AppConstant } from '@app/shared/constants';
import { FilterModel, CustomProductFilterModel, ShipmentFilterModel, ReassignPreviewRequest, ReassignPreviewResult, ReassignCustomProductsRequest, ReassignStoresRequest, ReassignStoresResult, ReassignWarehouseProductsRequest, ReassignStoreUsersRequest, ReassignStoreUsersResult, FlagshipUnassignedGroupsRequest, FlagshipUnassignedGroupsResult, FlagshipGroupProductsRequest, FlagshipGroupDetailResult } from '@app/shared/models/product';
import { Observable } from 'rxjs';
import { APIResponse } from '@app/shared/services/core/ICore.interface';
import { GetProductDetailsByProductIdInterface } from '@app/shared/services/product/getProductDetailsByProductId.interface';
import { GetCustomizedProductDetailsByProductIdInterface } from '@app/shared/services/product/getCustomizedProductDetailsByProductId.interface';
import { GetProductCategoyAndSubCategoryInterface } from '@app/shared/services/product/getProductCategoyAndSubCategory.interface';
import { GetAvgRatingInterface } from '@app/shared/services/product/getAvgRating.interface';
import { GetProductReviewsInterface } from '@app/shared/services/product/getProductReviews.interface';
import { UpdateProductTextInputInterface } from '@app/shared/services/product/updateProductText.interface';
import { UpdateDefaultProductImageInterface, UpdateShowCustomImageFlagInterface, UploadProductImagesInterface, ProductGetById } from './uploadProductImages.interface';
import { FormGroup } from '@angular/forms';
import { AddProductActualQuantity } from '../../../feature/super-admin/models/product-shipment';
import { ProductShopifyInterface, BulkInventory } from '../../components/inksofteditor/inksofteditor.interface';
import { UpdateDesignWithSelectedColors, SavedDesignfilterModel } from '../../../feature/store-admin/components/add-product-popup/add-product-popup.component';
import { InksoftDesignModel } from '@app/shared/models/InksoftDesignModel';
import { ManualPayment } from '../../components/embroidery-product-info/embroidery-product-info.component';


@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private http: HttpClient) { }

  /** Get all products based on filter(if any) */
  getAllProducts(filterModel: FilterModel) {
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.GET_PRODUCTS, filterModel);
  }
  downloadProductFeatures() {
    return this.http.get(environment.baseUrl + AppConstant.GET_PRODUCT_FEATURES_FILE, { responseType: 'blob' });
  }
  downloadShipCost() {
    return this.http.get(environment.baseUrl + AppConstant.GET_SHIP_COST_FILE, { responseType: 'blob' });
  }


  /** Get master filters data for master product(s) */
  getMasterProductFiltersData() {
    return this.http.get<APIResponse<{}>>(environment.baseUrl + AppConstant.GET_MASTER_PRODUCT_FILTERS);
  }

  /** Get filters data for custom product(s), only those filters which are present on the custom products */
  getCustomProductFiltersData(UserID: number) {
    return this.http.get<APIResponse<{}>>(environment.baseUrl + AppConstant.GET_FILTERS + '?UserId=' + UserID);
  }

  /** Get master filters data for customized product(s) */
  getCustomizedProductsMasterFiltersData() {
    return this.http.get<APIResponse<{}>>(environment.baseUrl + AppConstant.GET_CUSTOMIZED_PRODUCT_FILTERS);
  }

  /** Get master filters data for store front product(s) */
  getStorePublishProductMasterFiltersData(storeName: any) {
    return this.http.get<APIResponse<{}>>(environment.baseUrl + AppConstant.GET_CUSTOMIZED_PUBLISH_PRODUCT_FILTERS + '?StoreName=' + storeName);
  }

  getProductDetailsByProductId(productId: any) {
    return this.http.get<APIResponse<GetProductDetailsByProductIdInterface>>(environment.baseUrl + AppConstant.GET_PRODUCTDETAIL_BY_ID + '?ProductId=' + productId);
  }

  getCustomizedProductDetailsByProductId(productId: any, designId: any, storeid: any) {
    // tslint:disable-next-line:max-line-length
    return this.http.get<APIResponse<GetCustomizedProductDetailsByProductIdInterface>>(environment.baseUrl + AppConstant.GET_CUSTOMIZED_PRODUCT_DETAIL_BY_ID + '?ProductId=' + productId + '&DesignId=' + designId
      + '&StoreId=' + storeid);
  }

  /** Get product list categories */
  getProductCategoyAndSubCategory() {
    return this.http.get<APIResponse<GetProductCategoyAndSubCategoryInterface[]>>(environment.baseUrl + AppConstant.GET_PRODUCT_CATEGORIES);
  }

  getAvgRating(productId: any) {
    // TODO FIX this API
    return this.http.get<APIResponse<Number>>(environment.baseUrl + AppConstant.GET_AVG_RATING + '?ProductId=' + productId);
  }

  getProductReviews(productId: any, pageindex: number, pagesize: number) {
    return this.http.get<APIResponse<GetProductReviewsInterface>>(environment.baseUrl + AppConstant.GET_PRODUCT_REVIEWS + '?ProductId=' + productId +
      '&pageindex=' + pageindex + '&pagesize=' + pagesize);
  }
  getSizeQty(productId: any, styleId: any) {
    return this.http.get<APIResponse<{}>>(environment.baseUrl + AppConstant.GET_SIZE_QTY + '?ProductId=' + productId +
      '&UniqueStyleId=' + styleId);
  }
  updateProductText(data: UpdateProductTextInputInterface) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.http.post<APIResponse<{}>>(environment.baseUrl + '/Product/UpdateProductText', data, { headers: headers_1 });
  }

  uploadProductImages(data: UploadProductImagesInterface) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.SAVE_PRODUCT_IMAGES, data, { headers: headers_1 });
  }

  updateDefaultProductImage(data: UpdateDefaultProductImageInterface) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.SAVE_DEFAULT_PRODUCT_IMAGE, data, { headers: headers_1 });
  }

  updateShowCustomImageFlag(data: UpdateShowCustomImageFlagInterface) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.SAVE_CUSTOM_IMAGE_FLAG, data, { headers: headers_1 });
  }
  addCustomProduct(customDetail: any) {
    return this.http.post(environment.baseUrl + AppConstant.ADD_CUSTOM_PRODUCT, customDetail);
  }
  getAllCustomProducts(filterModel1: CustomProductFilterModel) {
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.GET_ALL_CUSTOM_PRODUCT, filterModel1);
  }
  getReassignStores(req: ReassignStoresRequest) {
    return this.http.post<APIResponse<ReassignStoresResult>>(environment.baseUrl + AppConstant.GET_REASSIGN_STORES, req);
  }
  getReassignStoreUsers(req: ReassignStoreUsersRequest) {
    return this.http.post<APIResponse<ReassignStoreUsersResult>>(environment.baseUrl + AppConstant.GET_REASSIGN_STORE_USERS, req);
  }
  getReassignPreview(req: ReassignPreviewRequest) {
    return this.http.post<APIResponse<ReassignPreviewResult>>(environment.baseUrl + AppConstant.GET_REASSIGN_PREVIEW, req);
  }
  reassignCustomProducts(req: ReassignCustomProductsRequest) {
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.REASSIGN_CUSTOM_PRODUCTS, req);
  }
  reassignWarehouseProducts(req: ReassignWarehouseProductsRequest) {
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.REASSIGN_WAREHOUSE_PRODUCTS, req);
  }
  getFlagshipUnassignedGroups(req: FlagshipUnassignedGroupsRequest) {
    return this.http.post<APIResponse<FlagshipUnassignedGroupsResult>>(environment.baseUrl + AppConstant.GET_FLAGSHIP_UNASSIGNED_GROUPS, req);
  }
  getFlagshipGroupProducts(req: FlagshipGroupProductsRequest) {
    return this.http.post<APIResponse<FlagshipGroupDetailResult>>(environment.baseUrl + AppConstant.GET_FLAGSHIP_GROUP_PRODUCTS, req);
  }
  getCustomProductsDetails(productID: any) {
    return this.http.get<APIResponse<{}>>(environment.baseUrl + AppConstant.GET_ALL_CUSTOM_PRODUCT_DETAILS + '?ProductId=' + productID);
  }
  approveCustomProduct(comment: any, approval: any, ProductId: number) {
    return this.http.get<APIResponse<{}>>(environment.baseUrl + AppConstant.UPDATE_APPROVAL_OF_CUSTOM_PRODUCT + '?Message=' + comment + '&Status=' + approval + '&ProductID=' + ProductId)
  }
  saveInventoryDetails(form: any) {
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.ADD_INVENTORY_DETAILS, form);
  }
  getShipmentDetails(filterModel: ShipmentFilterModel) {
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.Get_SHIPMENT_DETAILS, filterModel);
  }
  setProductActualQuantity(actualQuantityModal: AddProductActualQuantity) {
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.SAVE_PRODUCT_ACTUAL_COUNT, actualQuantityModal)
  }
  getEncryptedData(productId: any) {
    return this.http.get<string>(environment.baseUrl + AppConstant.ENCRYPT_DATA + '?SecureData=' + productId)
  }
  deleteWareHouseProduct(productId: any) {
    return this.http.get<string>(environment.baseUrl + AppConstant.DELETE_WAREHOUSE_PRODUCT_FROM_LIST + '?ProductId=' + productId);
  }
  getCustomizedProductDetailsWithStyle(getProductById: ProductGetById) {
    return this.http.get<any>(environment.baseUrl + AppConstant.GET_PRODUCTDETAIL_BY_ID_Style + '?ProductId=' + getProductById.productId + '&DesignId=' + getProductById.designId + '&StoreId=' + getProductById.storeId)
  }
  public updateCustomizedDesign(data: UpdateDesignWithSelectedColors) {
    return this.http.post<any>(environment.baseUrl + '/Product/UpdateColorsCustomizedProductShopify', data);
  }

  // ML Shopify node app calls START
  UpdateProductInShopify(data: ProductShopifyInterface) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('x-api-key', data.apiKey);
    return this.http.post<any>(environment.baseUrlShopifyApp + AppConstant.POST_DATA_SHOPIFY, data, { headers: headers_1 })
  }
  replaceProductInShopify(data: ProductShopifyInterface) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('x-api-key', data.apiKey);
    return this.http.post<any>(environment.baseUrlShopifyApp + AppConstant.REPLACE_PRODUCT_SHOPIFY, data, { headers: headers_1 })
  }

  
  getShopifyStoreKey(designId: any) {
    return this.http.post<any>(environment.baseUrlShopifyApp + AppConstant.GET_SHOPIFY_STORE, designId)
  }
  CreateWarehouseProductInShopify(data: ProductShopifyInterface) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('x-api-key', data.apiKey);
    return this.http.post<any>(environment.baseUrlShopifyApp + AppConstant.WAREHOUSE_PRODUCT_CREATE_SHOPIFY, data, { headers: headers_1 })
  }
  addInventoryShopifyStore(data: any) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('x-api-key', data.apiKey);
    return this.http.post<any>(environment.baseUrlShopifyApp + AppConstant.WAREHOUSE_INVENTORY_ADD_SHOPIFY, data, { headers: headers_1 })
  }
  //  ML Shopify node app calls END

  uploadProductFeatures(formdata: FormData) {
    return this.http.post<any>(environment.baseUrl + AppConstant.UPLOAD_PRODUCT_FEATURES, formdata);
  }
  getAdditionalProductDetails(productUniqueId: number, designId: number) {
    return this.http.get<APIResponse<any>>(environment.baseUrl + AppConstant.GET_ADDITIONAL_PRODUCT_DETAILS + '?ProductUniqueId=' + productUniqueId + '&DesignId=' + designId);
  }

  getMySavedDesign(filter: SavedDesignfilterModel) {
    return this.http.post<APIResponse<{}>>(environment.baseUrl + AppConstant.GET_MY_SAVED_DESIGN, filter);
  }

  getInkoftDesignDetails(inksoftBaseUrl: string, designId: number) {
    return this.http.get<InksoftDesignModel>(inksoftBaseUrl + '/GetDesignSummary?DesignId=' + designId + '&GetNotes=false&Format=JSON&GetColors=false&GetRegions=false');
  }
  fn_getEmbroideryProductDetailList(filter: any) {
    return this.http.post<any>(environment.baseUrl + '/Product/GetEmbroideryProductInfo', filter);
  }
  fn_SetManualPaymentForEmbroideryProduct(data: ManualPayment) {
    return this.http.post<any>(environment.baseUrl + '/Product/SetEmbroideryManulaPayment', data);
  }
  fn_CreateBulkOrder(Inventory: BulkInventory) {
    return this.http.post<any>(environment.baseUrl + '/Product/CreateBulkOrder', Inventory);
  }

  fn_GetBulkProductSummary(customizedId: number) {
    return this.http.get<any>(environment.baseUrl + '/Product/GetBulkProductSummary?CustomizedProductId=' + customizedId);
  }

  fn_GetBulkOrderDiscount() {
    return this.http.get<any>(environment.baseUrl + '/Product/GetBulkOrderDiscount');
  }
  fn_getInventoryHoldingPaymentList(filter: any) {
    return this.http.post<any>(environment.baseUrl + AppConstant.GET_WAREHOUSE_INVENTORY_PAYMENT_LIST, filter);
  }
  fn_SaveInventoryHoldingPayment(data: any) {
    return this.http.post<any>(environment.baseUrl + AppConstant.SAVE_WAREHOUSE_INVENTORY_PAYMENT, data);
  }
  uploadProductShipCost(formdata: FormData) {
    return this.http.post<any>(environment.baseUrl + AppConstant.UPLOAD_PRODUCT_SHIPCOST, formdata);
  }
  getDesignList(payload) {
    return this.http.post<any>(environment.baseUrl + '/Product/GetDesignList', payload);
  }
  addProductInShopify(data: any){
    const headers = new HttpHeaders();
    const headers_1 = headers.append('x-api-key', data.apiKey);
    return this.http.post<any>(environment.baseUrlShopifyApp + AppConstant.ADD_PRODUCT_SHOPIFY, data, { headers: headers_1 })
  }
  addProductInShopifyBulk(apiKey: string, products: any[]){
    const headers = new HttpHeaders().set('x-api-key', apiKey);
    return this.http.post<any>(
      environment.baseUrlShopifyApp + AppConstant.ADD_PRODUCT_SHOPIFY_BULK,
      { products },
      { headers }
    );
  }
  UpdateMetafield(data: any) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('x-api-key', data.apiKey);
    return this.http.post<any>(environment.baseUrlShopifyApp + '/api/product/addupdatemetafields', data, { headers: headers_1 })
  }
  UpdateTag(data: any) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('x-api-key', data.apiKey);
    return this.http.post<any>(environment.baseUrlShopifyApp + '/api/product/addUpdateTags', data, { headers: headers_1 })
  }

  /** Save customized product with design data */
  saveCustomizedProduct(productData: any) {
    return this.http.post<APIResponse<any>>(environment.baseUrl + AppConstant.SAVE_CUSTOMIZED_PRODUCT, productData);
  }

  UpdateDecorationTypeTags() {
    return this.http.post<APIResponse<{}>>(environment.baseUrl + '/Product/UpdateDecorationTypeTags', {});
  }
}
